function isDefaultOffice(officeValue: boolean): boolean {
  const isDefault = officeValue ? 'Yes' : true;
  if (isDefault) {
    return true;
  }
  return false;
}

export default isDefaultOffice;
